module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.modal.alert.show === true) ? 'in show' : '', 'modal fade alertGlobal'],
    attrs: {
      "id": "alertGlobal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.modal.alert.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), (this.$store.state.modal.alert.status) ? _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Sucesso! "), _c('span', [_vm._v(" :-) ")])]) : _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Algo deu errado! "), _c('span', [_vm._v(" :-( ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body",
    domProps: {
      "innerHTML": _vm._s(this.$store.state.modal.alert.msg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a491d2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/AlertGlobal.vue
// module id = 966
// module chunks = 1